import { useStyles } from "./styles";
import { IdName } from "@/main/models/common";
import { StatusManagePackagesEnum } from "@/main/services/enum/StatusManagePackagesEnum";

interface IOrderStatusProps {
	status: IdName;
}

export function renderColorManagerPackagesStatus(id: number) {
	switch (id) {
		case StatusManagePackagesEnum.OnTrack:
			return "#cccccc";
		case StatusManagePackagesEnum.AtRisk:
			return "#ffcc00";
		case StatusManagePackagesEnum.Delayed:
			return "#ff0000";
		default:
			return "#000";
	}
}

export default function StatusColorManagerPackages({ status }: IOrderStatusProps) {
	const classes = useStyles();

	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes.container}`}
			title={status.name}
			style={{ backgroundColor: renderColorManagerPackagesStatus(status.id) }}
		>
			<span className={classes.spanContainer}>{status.name}</span>
		</div>
	);
}
